import { GradingHeaderProps } from "../../types";
import Button from "../button/Button";
import IconButton from "../button/IconButton";
import { Wrapper, Text } from "./GradingHeader.styles";
import EyeIcon from "../../assets/images/eye.png";

function GradingHeader(props: GradingHeaderProps) {
  const {
    text,
    viewExample,
    viewExampleCallback,
    actionHandler,
    actionTitle,
    appPreview,
    loading,
  } = props;
  return (
    <Wrapper>
      <Text>{text}</Text>
      <div>
        {viewExample && (
          <IconButton
            onClick={viewExampleCallback ? viewExampleCallback : () => {}}
            text={appPreview ? "App Preview" : "View Example"}
            disabled={false}
            style={{
              width: "165px",
              height: "36px",
              padding: "10px 20px 10px 16px",
              fontSize: "14.5px",
              color: "#4D9FC4",
              background: "rgba(241, 244, 251, 1)",
              marginRight: "6px",
            }}
            icon={EyeIcon}
          />
        )}
        <Button
          style={{
            width: "150px",
            height: "36px",
            padding: "10px 20px",
            fontSize: "14.5px",
          }}
          onClick={actionHandler}
          text={Boolean(loading) ? "Please Wait" : actionTitle}
          disabled={Boolean(loading)}
        />
      </div>
    </Wrapper>
  );
}

export default GradingHeader;
